<template>
  <div>
    <section>
      <b-alert
        :show="successMessageDismissCountdown"
        dismissible
        variant="success"
        @dismissed="successMessageDismissCountdown = 0"
        @dismiss-count-down="countDownChanged"
      >
        <p>
          Der Teaser "{{ teaser.internalName }}" wurde erfolgreich gespeichert
        </p>
      </b-alert>
      <h2 v-if="!teaser._id">Neuer Teaser erfassen</h2>
      <h2 v-if="teaser._id">Teaser bearbeiten</h2>
      <div class="o-grid o-grid--no-gutter">
        <div class="o-grid__cell top-buttons">
          <bos-button @click="saveTeaser">Teaser speichern</bos-button>
        </div>
      </div>
    </section>
    <section>
      <tabs
        :options="{ useUrlFragment: false }"
        @clicked="tabClicked"
        @changed="tabChanged"
        class="bos-tabs"
      >
        <tab name="Typ" v-if="!teaser._id">
          <div class="o-grid o-grid--no-gutter">
            <div class="o-grid__cell o-grid__cell--width-100">
              <bos-input
                v-model="teaser.type"
                key="type"
                label="Typ:"
                :required="true"
                type="dropdown"
                :error="errors.type"
                @setOptions="setTeaserTypes"
              />
            </div>
          </div>
        </tab>
        <tab name="Inhalt">
          <div class="o-grid o-grid--no-gutter">
            <div class="o-grid__cell o-grid__cell--width-100">
              <bos-input
                v-model="teaser.internalName"
                key="internalName"
                :error="errors.internalName"
                label="Bezeichnung:"
                :required="true"
              />
              <h3 v-if="(teaser.type & 4) > 0">Teaser 1</h3>
              <bos-input
                v-model="teaser.titleDe"
                key="titleDe"
                :error="errors.titleDe"
                label="Titel (de):"
                :required="true"
                v-if="(teaser.type & 128) === 0"
              />
              <bos-input
                v-model="teaser.textDe"
                key="textDe"
                :error="errors.textDe"
                label="Text (de):"
                :required="true"
                v-if="(teaser.type & 128) === 0"
              />
              <bos-input
                v-model="teaser.titleFr"
                key="titleFr"
                :error="errors.titleFr"
                label="Titel (fr):"
                :required="true"
                v-if="(teaser.type & 128) === 0"
              />
              <bos-input
                v-model="teaser.textFr"
                key="textFr"
                :error="errors.textFr"
                label="Text (fr):"
                :required="true"
                v-if="(teaser.type & 128) === 0"
              />
              <bos-input
                v-model="teaser.titleEn"
                key="titleEn"
                :error="errors.titleEn"
                label="Titel (en):"
                :required="true"
                v-if="(teaser.type & 128) === 0"
              />
              <bos-input
                v-model="teaser.textEn"
                key="textEn"
                :error="errors.textEn"
                label="Text (en):"
                :required="true"
                v-if="(teaser.type & 128) === 0"
              />

              <hr />

              <bos-input
                v-model="teaser.leistungsgruppeId"
                key="leistungsgruppeId"
                label="Leistungsgruppe:"
                :required="false"
                type="dropdown"
                :error="errors.leistungsgruppeId"
                @setOptions="setLeistungsgruppeOptions"
              />

              <bos-input
                v-model="teaser.ctaTextDe"
                key="ctaTextDe"
                :error="errors.ctaTextDe"
                label="CTA - Text (de):"
                :required="true"
                v-if="(teaser.type & 128) === 0"
              />
              <bos-input
                v-model="teaser.ctaUrlDe"
                key="ctaUrlDe"
                :error="errors.ctaUrlDe"
                label="CTA - Link (de):"
                :required="false"
              />
              <bos-input
                v-model="teaser.ctaTextFr"
                key="ctaTextFr"
                :error="errors.ctaTextFr"
                label="CTA - Text (fr):"
                :required="true"
                v-if="(teaser.type & 128) === 0"
              />
              <bos-input
                v-model="teaser.ctaUrlFr"
                key="ctaUrlFr"
                :error="errors.ctaUrlFr"
                label="CTA - Link (fr):"
                :required="false"
              />
             <bos-input
                v-model="teaser.ctaTextEn"
                key="ctaTextEn"
                :error="errors.ctaTextEn"
                label="CTA - Text (en):"
                :required="true"
                v-if="(teaser.type & 128) === 0"
              />
              <bos-input
                v-model="teaser.ctaUrlEn"
                key="ctaUrlEn"
                :error="errors.ctaUrlEn"
                label="CTA - Link (en):"
                :required="false"
              />

              <hr v-if="(teaser.type & 128) === 0" />

              <bos-input
                v-model="teaser.eyecatcherTitleDe"
                key="eyecatcherTitleDe"
                label="Störer - Titel (de):"
                v-if="(teaser.type & 128) === 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTextDe"
                key="eyecatcherTextDe"
                label="Störer - Text (de):"
                v-if="(teaser.type & 128) === 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTitleFr"
                key="eyecatcherTitleFr"
                label="Störer - Titel (fr):"
                v-if="(teaser.type & 128) === 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTextFr"
                key="eyecatcherTextFr"
                label="Störer - Text (fr):"
                v-if="(teaser.type & 128) === 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTitleEn"
                key="eyecatcherTitleEn"
                label="Störer - Titel (en):"
                v-if="(teaser.type & 128) === 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTextEn"
                key="eyecatcherTextEn"
                label="Störer - Text (en):"
                v-if="(teaser.type & 128) === 0"
              />

              <hr v-if="(teaser.type & 4) > 0" />

              <h3 v-if="(teaser.type & 4) > 0">Teaser 2</h3>
              <bos-input
                v-model="teaser.titleDe2"
                key="titleDe2"
                :error="errors.titleDe2"
                label="Titel (de):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.textDe2"
                key="textDe2"
                :error="errors.textDe2"
                label="Text (de):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.titleFr2"
                key="titleFr2"
                :error="errors.titleFr2"
                label="Titel (fr):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.textFr2"
                key="textFr2"
                :error="errors.textFr2"
                label="Text (fr):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.titleEn2"
                key="titleEn2"
                :error="errors.titleEn2"
                label="Titel (en):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.textEn2"
                key="textEn2"
                :error="errors.textEn2"
                label="Text (en):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />

              <hr v-if="(teaser.type & 4) > 0" />

              <bos-input
                v-model="teaser.ctaTextDe2"
                key="ctaTextDe2"
                :error="errors.ctaTextDe2"
                label="CTA - Text (de):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.ctaUrlDe2"
                key="ctaUrlDe2"
                :error="errors.ctaUrlDe2"
                label="CTA - Link (de):"
                :required="true"
                v-if="(teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.ctaTextFr2"
                key="ctaTextFr2"
                :error="errors.ctaTextFr2"
                label="CTA - Text (fr):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.ctaUrlFr2"
                key="ctaUrlFr2"
                :error="errors.ctaUrlFr2"
                label="CTA - Link (fr):"
                :required="true"
                v-if="(teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.ctaTextEn2"
                key="ctaTextEn2"
                :error="errors.ctaTextEn2"
                label="CTA - Text (en):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.ctaUrlEn2"
                key="ctaUrlEn2"
                :error="errors.ctaUrlEn2"
                label="CTA - Link (en):"
                :required="true"
                v-if="(teaser.type & 4) > 0"
              />

              <hr v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0" />

              <bos-input
                v-model="teaser.eyecatcherTitleDe2"
                key="eyecatcherTitleDe2"
                label="Störer - Titel (de):"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTextDe2"
                key="eyecatcherTextDe2"
                label="Störer - Text (de):"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTitleFr2"
                key="eyecatcherTitleFr2"
                label="Störer - Titel (fr):"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTextFr2"
                key="eyecatcherTextFr2"
                label="Störer - Text (fr):"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTitleEn2"
                key="eyecatcherTitleEn2"
                label="Störer - Titel (en):"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTextEn2"
                key="eyecatcherTextEn2"
                label="Störer - Text (en):"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />

              <hr v-if="(teaser.type & 4) > 0" />

              <h3 v-if="(teaser.type & 4) > 0">Teaser 3</h3>
              <bos-input
                v-model="teaser.titleDe3"
                key="titleDe3"
                :error="errors.titleDe3"
                label="Titel (de):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.textDe3"
                key="textDe3"
                :error="errors.textDe3"
                label="Text (de):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.titleFr3"
                key="titleFr3"
                :error="errors.titleFr3"
                label="Titel (fr):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.textFr3"
                key="textFr3"
                :error="errors.textFr3"
                label="Text (fr):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.titleEn3"
                key="titleEn3"
                :error="errors.titleEn3"
                label="Titel (en):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.textEn3"
                key="textEn3"
                :error="errors.textEn3"
                label="Text (en):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />

              <hr v-if="(teaser.type & 4) > 0" />

              <bos-input
                v-model="teaser.ctaTextDe3"
                key="ctaTextDe3"
                :error="errors.ctaTextDe3"
                label="CTA - Text (de):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.ctaUrlDe3"
                key="ctaUrlDe3"
                :error="errors.ctaUrlDe3"
                label="CTA - Link (de):"
                :required="true"
                v-if="(teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.ctaTextFr3"
                key="ctaTextFr3"
                :error="errors.ctaTextFr3"
                label="CTA - Text (fr):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.ctaUrlFr3"
                key="ctaUrlFr3"
                :error="errors.ctaUrlFr3"
                label="CTA - Link (fr):"
                :required="true"
                v-if="(teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.ctaTextEn3"
                key="ctaTextEn3"
                :error="errors.ctaTextEn3"
                label="CTA - Text (en):"
                :required="true"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.ctaUrlEn3"
                key="ctaUrlEn3"
                :error="errors.ctaUrlEn3"
                label="CTA - Link (en):"
                :required="true"
                v-if="(teaser.type & 4) > 0"
              />

              <hr v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0" />

              <bos-input
                v-model="teaser.eyecatcherTitleDe3"
                key="eyecatcherTitleDe3"
                label="Störer - Titel (de):"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTextDe3"
                key="eyecatcherTextDe3"
                label="Störer - Text (de):"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTitleFr3"
                key="eyecatcherTitleFr3"
                label="Störer - Titel (fr):"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTextFr3"
                key="eyecatcherTextFr3"
                label="Störer - Text (fr):"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTitleEn3"
                key="eyecatcherTitleEn3"
                label="Störer - Titel (en):"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
              <bos-input
                v-model="teaser.eyecatcherTextEn3"
                key="eyecatcherTextEn3"
                label="Störer - Text (en):"
                v-if="(teaser.type & 128) === 0 && (teaser.type & 4) > 0"
              />
            </div>
          </div>
        </tab>
        <tab name="Bilder">
          <div class="o-grid o-grid--no-gutter">
            <div class="o-grid__cell o-grid__cell--width-100">
              <h3 v-if="(teaser.type & 4) > 0">Teaser 1</h3>

              <image-uploader
                :debug="1"
                :maxWidth="imageLandscapeMaxWidth"
                :maxHeight="imageLandscapeMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imageLandscapeDe.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImageLandscapeDe"
                id="fileInputImageLandscapeDe"
              >
                <label for="fileInputImageLandscapeDe" slot="upload-label"
                  >Bild - Desktop<span v-if="(teaser.type & 128) > 0">
                    (de)</span
                  ><sup v-if="(teaser.type & 1) > 0 || (teaser.type & 128) > 0"
                    >*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imageLandscapeMaxWidth }}x{{
                      imageLandscapeMaxHeight
                    }}px<br />Seitenverhältniss: {{ imageLandscapeAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imageLandscapeDe">
                <img
                  v-bind:src="teaser.imageLandscapeDe"
                  ref="fileInputImageLandscapeDe_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imageLandscapeDe.hasError"
                >
                  {{ this.errors.imageLandscapeDe.errorText }}
                </div>
                <a @click="clearImage" data-image="imageLandscapeDe"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imagePortraitMaxWidth"
                :maxHeight="imagePortraitMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imagePortraitDe.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImagePortraitDe"
                id="fileInputImagePortraitDe"
              >
                <label for="fileInputImagePortraitDe" slot="upload-label"
                  >Bild - Mobile<span v-if="(teaser.type & 128) > 0"> (de)</span
                  ><sup v-if="(teaser.type & 1) > 0 || (teaser.type & 128) > 0"
                    >*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imagePortraitMaxWidth }}x{{
                      imagePortraitMaxHeight
                    }}px<br />Seitenverhältniss: {{ imagePortraitAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imagePortraitDe">
                <img
                  v-bind:src="teaser.imagePortraitDe"
                  ref="fileInputImagePortraitDe_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imagePortraitDe.hasError"
                >
                  {{ this.errors.imagePortraitDe.errorText }}
                </div>
                <a @click="clearImage" data-image="imagePortraitDe"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imageLandscapeMaxWidth"
                :maxHeight="imageLandscapeMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imageLandscapeFr.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImageLandscapeFr"
                v-if="(teaser.type & 128) > 0"
                id="fileInputImageLandscapeFr"
              >
                <label for="fileInputImageLandscapeFr" slot="upload-label"
                  >Bild - Desktop (fr)<sup v-if="(teaser.type & 128) > 0">*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imageLandscapeMaxWidth }}x{{
                      imageLandscapeMaxHeight
                    }}px<br />Seitenverhältniss: {{ imageLandscapeAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imageLandscapeFr">
                <img
                  v-bind:src="teaser.imageLandscapeFr"
                  ref="fileInputImageLandscapeFr_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imageLandscapeFr.hasError"
                >
                  {{ this.errors.imageLandscapeFr.errorText }}
                </div>
                <a @click="clearImage" data-image="imageLandscapeFr"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imagePortraitMaxWidth"
                :maxHeight="imagePortraitMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imagePortraitFr.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImagePortraitFr"
                v-if="(teaser.type & 128) > 0"
                id="fileInputImagePortraitFr"
              >
                <label for="fileInputImagePortraitFr" slot="upload-label"
                  >Bild - Mobile (fr)<sup v-if="(teaser.type & 128) > 0">*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imagePortraitMaxWidth }}x{{
                      imagePortraitMaxHeight
                    }}px<br />Seitenverhältniss: {{ imagePortraitAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imagePortraitFr">
                <img
                  v-bind:src="teaser.imagePortraitFr"
                  ref="fileInputImagePortraitFr_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imagePortraitFr.hasError"
                >
                  {{ this.errors.imagePortraitFr.errorText }}
                </div>
                <a @click="clearImage" data-image="imagePortraitFr"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imageLandscapeMaxWidth"
                :maxHeight="imageLandscapeMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imageLandscapeEn.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImageLandscapeEn"
                v-if="(teaser.type & 128) > 0"
                id="fileInputImageLandscapeEn"
              >
                <label for="fileInputImageLandscapeEn" slot="upload-label"
                  >Bild - Desktop (en)<sup v-if="(teaser.type & 128) > 0">*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imageLandscapeMaxWidth }}x{{
                      imageLandscapeMaxHeight
                    }}px<br />Seitenverhältniss: {{ imageLandscapeAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imageLandscapeEn">
                <img
                  v-bind:src="teaser.imageLandscapeEn"
                  ref="fileInputImageLandscapeEn_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imageLandscapeEn.hasError"
                >
                  {{ this.errors.imageLandscapeEn.errorText }}
                </div>
                <a @click="clearImage" data-image="imageLandscapeEn"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imagePortraitMaxWidth"
                :maxHeight="imagePortraitMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imagePortraitEn.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImagePortraitEn"
                v-if="(teaser.type & 128) > 0"
                id="fileInputImagePortraitEn"
              >
                <label for="fileInputImagePortraitEn" slot="upload-label"
                  >Bild - Mobile (en)<sup v-if="(teaser.type & 128) > 0">*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imageLandscapeMaxWidth }}x{{
                      imageLandscapeMaxHeight
                    }}px<br />Seitenverhältniss: {{ imageLandscapeAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imagePortraitEn">
                <img
                  v-bind:src="teaser.imagePortraitEn"
                  ref="fileInputImagePortraitEn_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imagePortraitEn.hasError"
                >
                  {{ this.errors.imagePortraitEn.errorText }}
                </div>
                <a @click="clearImage" data-image="imagePortraitEn"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <hr v-if="(teaser.type & 4) > 0" />

              <h3 v-if="(teaser.type & 4) > 0">Teaser 2</h3>

              <image-uploader
                :debug="1"
                :maxWidth="imageLandscapeMaxWidth"
                :maxHeight="imageLandscapeMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imageLandscapeDe2.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImageLandscapeDe2"
                v-if="(teaser.type & 4) > 0"
                id="fileInputImageLandscapeDe2"
              >
                <label for="fileInputImageLandscapeDe2" slot="upload-label"
                  >Bild - Desktop (de)<sup
                    v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                    >*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imageLandscapeMaxWidth }}x{{
                      imageLandscapeMaxHeight
                    }}px<br />Seitenverhältniss: {{ imageLandscapeAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imageLandscapeDe2">
                <img
                  v-bind:src="teaser.imageLandscapeDe2"
                  ref="fileInputImageLandscapeDe2_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imageLandscapeDe2.hasError"
                >
                  {{ this.errors.imageLandscapeDe2.errorText }}
                </div>
                <a @click="clearImage" data-image="imageLandscapeDe2"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imagePortraitMaxWidth"
                :maxHeight="imagePortraitMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imagePortraitDe2.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImagePortraitDe2"
                v-if="(teaser.type & 4) > 0"
                id="fileInputImagePortraitDe2"
              >
                <label for="fileInputImagePortraitDe2" slot="upload-label"
                  >Bild - Mobile (de)<sup
                    v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                    >*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imagePortraitMaxWidth }}x{{
                      imagePortraitMaxHeight
                    }}px<br />Seitenverhältniss: {{ imagePortraitAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imagePortraitDe2">
                <img
                  v-bind:src="teaser.imagePortraitDe2"
                  ref="fileInputImagePortraitDe2_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imagePortraitDe2.hasError"
                >
                  {{ this.errors.imagePortraitDe2.errorText }}
                </div>
                <a @click="clearImage" data-image="imagePortraitDe2"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imageLandscapeMaxWidth"
                :maxHeight="imageLandscapeMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imageLandscapeFr2.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImageLandscapeFr2"
                v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                id="fileInputImageLandscapeFr2"
              >
                <label for="fileInputImageLandscapeFr2" slot="upload-label"
                  >Bild - Desktop (fr)<sup
                    v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                    >*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imageLandscapeMaxWidth }}x{{
                      imageLandscapeMaxHeight
                    }}px<br />Seitenverhältniss: {{ imageLandscapeAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imageLandscapeFr2">
                <img
                  v-bind:src="teaser.imageLandscapeFr2"
                  ref="fileInputImageLandscapeFr2_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imageLandscapeFr2.hasError"
                >
                  {{ this.errors.imageLandscapeFr2.errorText }}
                </div>
                <a @click="clearImage" data-image="imageLandscapeFr2"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imagePortraitMaxWidth"
                :maxHeight="imagePortraitMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imagePortraitFr2.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImagePortraitFr2"
                v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                id="fileInputImagePortraitFr2"
              >
                <label for="fileInputImagePortraitFr2" slot="upload-label"
                  >Bild - Mobile (fr)<sup
                    v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                    >*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imagePortraitMaxWidth }}x{{
                      imagePortraitMaxHeight
                    }}px<br />Seitenverhältniss: {{ imagePortraitAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imagePortraitFr2">
                <img
                  v-bind:src="teaser.imagePortraitFr2"
                  ref="fileInputImagePortraitFr2_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imagePortraitFr2.hasError"
                >
                  {{ this.errors.imagePortraitFr2.errorText }}
                </div>
                <a @click="clearImage" data-image="imagePortraitFr2"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imageLandscapeMaxWidth"
                :maxHeight="imageLandscapeMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imageLandscapeEn2.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImageLandscapeEn2"
                v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                id="fileInputImageLandscapeEn2"
              >
                <label for="fileInputImageLandscapeEn2" slot="upload-label"
                  >Bild - Desktop (en)<sup
                    v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                    >*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imageLandscapeMaxWidth }}x{{
                      imageLandscapeMaxHeight
                    }}px<br />Seitenverhältniss: {{ imageLandscapeAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imageLandscapeEn2">
                <img
                  v-bind:src="teaser.imageLandscapeEn2"
                  ref="fileInputImageLandscapeEn2_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imageLandscapeEn2.hasError"
                >
                  {{ this.errors.imageLandscapeEn2.errorText }}
                </div>
                <a @click="clearImage" data-image="imageLandscapeEn2"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imagePortraitMaxWidth"
                :maxHeight="imagePortraitMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imagePortraitEn2.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImagePortraitEn2"
                v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                id="fileInputImagePortraitEn2"
              >
                <label for="fileInputImagePortraitEn2" slot="upload-label"
                  >Bild - Mobile (en)<sup
                    v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                    >*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imagePortraitMaxWidth }}x{{
                      imagePortraitMaxHeight
                    }}px<br />Seitenverhältniss: {{ imagePortraitAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imagePortraitEn2">
                <img
                  v-bind:src="teaser.imagePortraitEn2"
                  ref="fileInputImagePortraitEn2_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imagePortraitEn2.hasError"
                >
                  {{ this.errors.imagePortraitEn2.errorText }}
                </div>
                <a @click="clearImage" data-image="imagePortraitEn2"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <hr v-if="(teaser.type & 4) > 0" />

              <h3 v-if="(teaser.type & 4) > 0">Teaser 3</h3>

              <image-uploader
                :debug="1"
                :maxWidth="imageLandscapeMaxWidth"
                :maxHeight="imageLandscapeMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imageLandscapeDe3.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImageLandscapeDe3"
                v-if="(teaser.type & 4) > 0"
                id="fileInputImageLandscapeDe3"
              >
                <label for="fileInputImageLandscapeDe3" slot="upload-label"
                  >Bild - Desktop (de)<sup
                    v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                    >*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imageLandscapeMaxWidth }}x{{
                      imageLandscapeMaxHeight
                    }}px<br />Seitenverhältniss: {{ imageLandscapeAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imageLandscapeDe3">
                <img
                  v-bind:src="teaser.imageLandscapeDe3"
                  ref="fileInputImageLandscapeDe3_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imageLandscapeDe3.hasError"
                >
                  {{ this.errors.imageLandscapeDe3.errorText }}
                </div>
                <a @click="clearImage" data-image="imageLandscapeDe3"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imagePortraitMaxWidth"
                :maxHeight="imagePortraitMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imagePortraitDe3.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImagePortraitDe3"
                v-if="(teaser.type & 4) > 0"
                id="fileInputImagePortraitDe3"
              >
                <label for="fileInputImagePortraitDe3" slot="upload-label"
                  >Bild - Mobile (de)<sup
                    v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                    >*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imagePortraitMaxWidth }}x{{
                      imagePortraitMaxHeight
                    }}px<br />Seitenverhältniss: {{ imagePortraitAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imagePortraitDe3">
                <img
                  v-bind:src="teaser.imagePortraitDe3"
                  ref="fileInputImagePortraitDe3_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imagePortraitDe3.hasError"
                >
                  {{ this.errors.imagePortraitDe3.errorText }}
                </div>
                <a @click="clearImage" data-image="imagePortraitDe3"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imageLandscapeMaxWidth"
                :maxHeight="imageLandscapeMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imageLandscapeFr3.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImageLandscapeFr3"
                v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                id="fileInputImageLandscapeFr3"
              >
                <label for="fileInputImageLandscapeFr3" slot="upload-label"
                  >Bild - Desktop (fr)<sup
                    v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                    >*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imageLandscapeMaxWidth }}x{{
                      imageLandscapeMaxHeight
                    }}px<br />Seitenverhältniss: {{ imageLandscapeAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imageLandscapeFr3">
                <img
                  v-bind:src="teaser.imageLandscapeFr3"
                  ref="fileInputImageLandscapeFr3_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imageLandscapeFr3.hasError"
                >
                  {{ this.errors.imageLandscapeFr3.errorText }}
                </div>
                <a @click="clearImage" data-image="imageLandscapeFr3"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imagePortraitMaxWidth"
                :maxHeight="imagePortraitMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imagePortraitFr3.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImagePortraitFr3"
                v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                id="fileInputImagePortraitFr3"
              >
                <label for="fileInputImagePortraitFr3" slot="upload-label"
                  >Bild - Mobile (fr)<sup
                    v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                    >*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imagePortraitMaxWidth }}x{{
                      imagePortraitMaxHeight
                    }}px<br />Seitenverhältniss: {{ imagePortraitAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imagePortraitFr3">
                <img
                  v-bind:src="teaser.imagePortraitFr3"
                  ref="fileInputImagePortraitFr3_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imagePortraitFr3.hasError"
                >
                  {{ this.errors.imagePortraitFr3.errorText }}
                </div>
                <a @click="clearImage" data-image="imagePortraitFr3"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imageLandscapeMaxWidth"
                :maxHeight="imageLandscapeMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imageLandscapeEn3.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImageLandscapeEn3"
                v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                id="fileInputImageLandscapeEn3"
              >
                <label for="fileInputImageLandscapeEn3" slot="upload-label"
                  >Bild - Desktop (en)<sup
                    v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                    >*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imageLandscapeMaxWidth }}x{{
                      imageLandscapeMaxHeight
                    }}px<br />Seitenverhältniss: {{ imageLandscapeAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imageLandscapeEn3">
                <img
                  v-bind:src="teaser.imageLandscapeEn3"
                  ref="fileInputImageLandscapeEn3_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imageLandscapeEn3.hasError"
                >
                  {{ this.errors.imageLandscapeEn3.errorText }}
                </div>
                <a @click="clearImage" data-image="imageLandscapeEn3"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>

              <image-uploader
                :debug="1"
                :maxWidth="imagePortraitMaxWidth"
                :maxHeight="imagePortraitMaxHeight"
                :quality="0.7"
                :autoRotate="true"
                outputFormat="verbose"
                :preview="false"
                :className="[
                  'fileinput',
                  { error: this.errors.imagePortraitEn3.hasError }
                ]"
                capture="environment"
                accept="video/*,image/*"
                doNotResize="['gif', 'svg']"
                @input="setImagePortraitEn3"
                v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                id="fileInputImagePortraitEn3"
              >
                <label for="fileInputImagePortraitEn3" slot="upload-label"
                  >Bild - Mobile (en)<sup
                    v-if="(teaser.type & 4) > 0 && (teaser.type & 128) > 0"
                    >*</sup
                  >:
                  <div class="hint">
                    Min. Grösse: {{ imagePortraitMaxWidth }}x{{
                      imagePortraitMaxHeight
                    }}px<br />Seitenverhältniss: {{ imagePortraitAspectRatio }}
                  </div></label
                >
              </image-uploader>
              <div v-if="teaser.imagePortraitEn3">
                <img
                  v-bind:src="teaser.imagePortraitEn3"
                  ref="fileInputImagePortraitEn3_preview"
                  class="preview-image"
                /><br />
                <div
                  class="c-errormessage"
                  v-if="this.errors.imagePortraitEn3.hasError"
                >
                  {{ this.errors.imagePortraitEn3.errorText }}
                </div>
                <a @click="clearImage" data-image="imagePortraitEn3"
                  >Bild entfernen</a
                ><br />
                <br />
              </div>
            </div>
          </div>
        </tab>
        <tab name="Optionen">
          <div class="o-grid o-grid--no-gutter">
            <div class="o-grid__cell o-grid__cell--width-100">
              <bos-input
                v-model="teaser.published"
                key="published"
                :error="errors.published"
                label="Publikation (von/bis):"
                type="daterange"
              />
              <bos-input
                v-model="teaser.fairSeries"
                key="fairSeries"
                :error="errors.fairSeries"
                label="Messe-Reihe:"
                @setOptions="setFairSeries"
                type="dropdown"
                :required="false"
                v-if="(teaser.type & 1) > 0"
              />
              <bos-input
                v-model="teaser.fair"
                key="fair"
                :error="errors.fair"
                label="Messe:"
                type="dropdown"
                :required="true"
                @setOptions="setFairs"
                @input="setFair"
                v-if="(teaser.type & 1) === 0"
              />
              <bos-input
                v-model="teaser.registrationState"
                key="registrationState"
                :error="errors.registrationState"
                label="Status Stand Anmeldung:"
                :required="true"
                type="bitMaskCheckboxes"
                @setOptions="setFairStates"
                v-if="(teaser.type & 1) === 0"
              />
              <bos-input
                v-model="teaser.relatedTask"
                key="relatedTask"
                :error="errors.relatedTask"
                label="Korrelation zu Aufgabe:"
                type="dropdown"
                :required="true"
                @setOptions="setFairRelatedTasks"
                v-if="(teaser.type & 1) === 0"
              />
            </div>
          </div>
        </tab>
      </tabs>
    </section>
  </div>
</template>

<script>
import { Tabs, Tab } from 'vue-tabs-component'
import BosButton from '@/components/BosButton'
import BosInput from '@/components/BosInput'
import ApiService from '@/services/ApiService'
import FormValidator from '@/services/FormValidator'
import { BAlert } from 'bootstrap-vue'

export default {
  name: 'AdminCreateTeaser',
  components: {
    //BosDocumentEntry,
    BosInput,
    BosButton,
    Tabs,
    Tab,
    BAlert
  },
  props: {
    msg: String
  },
  data() {
    return {
      successMessageDismissCountdown: 0,
      docs: [],
      steps: [],
      editStep: null,
      taskDefinitions: [],
      editDoc: {},
      relatedTasksOptions: null,
      teaser: {
        imagePortraitDe: null,
        imageLandscapeDe: null,
        imageLandscapeFr: null,
        imagePortraitFr: null,
        imageLandscapeEn: null,
        imagePortraitEn: null,
        imageLandscapeDe2: null,
        imagePortraitDe2: null,
        imageLandscapeFr2: null,
        imagePortraitFr2: null,
        imageLandscapeEn2: null,
        imagePortraitEn2: null,
        imageLandscapeDe3: null,
        imagePortraitDe3: null,
        imageLandscapeFr3: null,
        imagePortraitFr3: null,
        imageLandscapeEn3: null,
        imagePortraitEn3: null,
        type: 1,
        tasks: [],
        documents: [],
        steps: [],
        relatedTask: ''
      },
      errors: {
        internalName: {
          hasError: false
        },
        titleDe: {
          hasError: false
        },
        textDe: {
          hasError: false
        },
        titleFr: {
          hasError: false
        },
        textFr: {
          hasError: false
        },
        titleEn: {
          hasError: false
        },
        textEn: {
          hasError: false
        },
        ctaTextDe: {
          hasError: false
        },
        ctaUrlDe: {
          hasError: false
        },
        ctaTextFr: {
          hasError: false
        },
        ctaUrlFr: {
          hasError: false
        },
        ctaTextEn: {
          hasError: false
        },
        ctaUrlEn: {
          hasError: false
        },
        titleDe2: {
          hasError: false
        },
        textDe2: {
          hasError: false
        },
        titleFr2: {
          hasError: false
        },
        textFr2: {
          hasError: false
        },
        titleEn2: {
          hasError: false
        },
        textEn2: {
          hasError: false
        },
        ctaTextDe2: {
          hasError: false
        },
        ctaUrlDe2: {
          hasError: false
        },
        ctaTextFr2: {
          hasError: false
        },
        ctaUrlFr2: {
          hasError: false
        },
        ctaTextEn2: {
          hasError: false
        },
        ctaUrlEn2: {
          hasError: false
        },
        titleDe3: {
          hasError: false
        },
        textDe3: {
          hasError: false
        },
        titleFr3: {
          hasError: false
        },
        textFr3: {
          hasError: false
        },
        titleEn3: {
          hasError: false
        },
        textEn3: {
          hasError: false
        },
        ctaTextDe3: {
          hasError: false
        },
        ctaUrlDe3: {
          hasError: false
        },
        ctaTextFr3: {
          hasError: false
        },
        ctaUrlFr3: {
          hasError: false
        },
        ctaTextEn3: {
          hasError: false
        },
        ctaUrlEn3: {
          hasError: false
        },
        published: {
          hasError: false
        },
        fair: {
          hasError: false
        },
        fairType: {
          hasError: false
        },
        registrationState: {
          hasError: false
        },
        relatedTask: {
          hasError: false
        },
        imageLandscapeDe: {
          hasError: false
        },
        imagePortraitDe: {
          hasError: false
        },
        imageLandscapeFr: {
          hasError: false
        },
        imagePortraitFr: {
          hasError: false
        },
        imageLandscapeEn: {
          hasError: false
        },
        imagePortraitEn: {
          hasError: false
        },
        imageLandscapeDe2: {
          hasError: false
        },
        imagePortraitDe2: {
          hasError: false
        },
        imageLandscapeFr2: {
          hasError: false
        },
        imagePortraitFr2: {
          hasError: false
        },
        imageLandscapeEn2: {
          hasError: false
        },
        imagePortraitEn2: {
          hasError: false
        },
        imageLandscapeDe3: {
          hasError: false
        },
        imagePortraitDe3: {
          hasError: false
        },
        imageLandscapeFr3: {
          hasError: false
        },
        imagePortraitFr3: {
          hasError: false
        },
        imageLandscapeEn3: {
          hasError: false
        },
        imagePortraitEn3: {
          hasError: false
        }
      },
      flowStep: {}
    }
  },
  /*
      { value: 2, text: 'Mittel' },
      { value: 130, text: 'Mittel - nur Bild' },
      { value: 4, text: 'Klein (3er Gruppe)' },
      { value: 132, text: 'Klein (3er Gruppe) - nur Bild' },
      { value: 136, text: 'Klein (einzeln) - nur Bild' }

 */
  computed: {
    imageLandscapeMaxWidth() {
      switch (parseInt(this.teaser.type)) {
        case 1:
          return 1800
        case 129:
          return 1600
        case 2:
          return 600
        case 130:
          return 1600
        case 4:
          return 600
        case 132:
        case 136:
          return 1000
        default:
          return 400
      }
    },
    imageLandscapeMaxHeight() {
      switch (parseInt(this.teaser.type)) {
        case 1:
          return 1200
        case 129:
          return 800
        case 2:
          return 600
        case 130:
          return 480
        case 4:
          return 420
        case 132:
        case 136:
          return 1200
        default:
          return 400
      }
    },
    imageLandscapeAspectRatio() {
      return this.aspectRationName(
        this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight
      )
    },
    imagePortraitMaxWidth() {
      switch (parseInt(this.teaser.type)) {
        case 1:
          return 1800
        case 129:
          return 1000
        case 2:
          return 1200
        case 130:
          return 1000
        case 4:
          return 1200
        case 132:
        case 136:
          return 1000
        default:
          return 400
      }
    },
    imagePortraitMaxHeight() {
      switch (parseInt(this.teaser.type)) {
        case 1:
          return 600
        case 129:
          return 1200
        case 2:
          return 720
        case 130:
          return 1200
        case 4:
          return 720
        case 132:
        case 136:
          return 1200
        default:
          return 400
      }
    },
    imagePortraitAspectRatio() {
      return this.aspectRationName(
        this.imagePortraitMaxWidth / this.imagePortraitMaxHeight
      )
    }
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.successMessageDismissCountdown = dismissCountDown
    },
    aspectRationName(ratio) {
      const ratioKey = Math.floor(ratio * 1000)
      switch (ratioKey) {
        case 1500:
          return '3:2'
        case 3000:
          return '3:1'
        case 2000:
          return '2:1'
        case 833:
          return '5:6'
        case 1000:
          return '1:1'
        case 1666:
          return '5:3'
        case 3333:
          return '10:3'
        case 1428:
          return '10:7'
        default:
          return '?'
      }
    },
    setFairSeries(options) {
      ApiService.getFairSeries().then(response => {
        while (options.length > 0) {
          options.pop()
        }
        options.push({
          value: '',
          text: '-'
        })
        for (var i = 0; i < response.data.length; i++) {
          options.push({
            value: response.data[i]._id,
            text: response.data[i].titleDe
          })
        }
      })
    },
    setTeaserTypes(options) {
      ApiService.getTeaserTypes().then(response => {
        while (options.length > 0) {
          options.pop()
        }
        for (var idx in response.data) {
          options.push(response.data[idx])
        }
      })
    },
    setFairStates(options) {
      ApiService.getFairStates().then(response => {
        while (options.length > 0) {
          options.pop()
        }
        for (var idx in response.data) {
          options.push(response.data[idx])
        }
      })
    },
    setFairRelatedTasks(options) {
      while (options.length > 0) {
        options.pop()
      }
      options.push({
        value: '',
        text: '-'
      })
      this.relatedTasksOptions = options
    },
    setFair() {
      if (this.teaser.fair !== undefined && this.teaser.fair !== '') {
        ApiService.getFair(this.teaser.fair).then(result => {
          while (this.relatedTasksOptions.length > 0) {
            this.relatedTasksOptions.pop()
          }
          this.relatedTasksOptions.push({
            value: '',
            text: '-'
          })

          for (let i = 0; i < result.data.tasks.length; i++) {
            if (result.data.tasks[i].type === 'task') {
              this.relatedTasksOptions.push({
                value: result.data.tasks[i]._id,
                text: result.data.tasks[i].displayNameDe
              })
            }
          }
        })
      }
    },
    setFairs(options) {
      ApiService.getFairsWithTasks().then(response => {
        while (options.length > 0) {
          options.pop()
        }
        options.push({
          value: '',
          text: '-'
        })
        for (var i = 0; i < response.data.length; i++) {
          options.push({
            value: response.data[i]._id,
            text: response.data[i].displayNameDe
          })
        }
      })
    },
    setLeistungsgruppeOptions(options) {
      ApiService.getTaskDefinitions().then(response => {
        while (options.length > 0) {
          options.pop()
        }
        options.push({
          value: '',
          text: '-'
        })
        for (var i = 0; i < response.data.length; i++) {
          console.log(response.data[i]);
          options.push({
            value: response.data[i].serviceGroup,
            text: `${response.data[i].displayNameDe} (${response.data[i].serviceGroup})`
          })
        }
      })
    },
    setEditStep(task) {
      this.editStep = task
    },
    reopenStep(step) {
      //this.editStep = step
      console.log(step)
    },
    updateStep() {
      this.teaser.steps.push(this.$refs.stepForm.value)
      this.flowStep = {}
    },
    updateDoc() {
      this.teaser.documents.push(this.$refs.docForm.value)
      this.editDoc = {}
    },
    tabClicked() {
      return
    },
    tabChanged() {
      return
    },
    clearImage(e) {
      this.errors[e.currentTarget.getAttribute('data-image')].hasError = false
      this.teaser[e.currentTarget.getAttribute('data-image')] = null
    },
    getValidationRules() {
      //rules
      const that = this
      var validationRules = [
        {
          value: this.teaser.internalName,
          required: true,
          errorKey: 'internalName',
          tab: 'inhalt'
        },
        {
          value: this.teaser.titleDe,
          required: (this.teaser.type & 128) === 0,
          errorKey: 'titleDe',
          tab: 'inhalt'
        },
        {
          value: this.teaser.textDe,
          required: (this.teaser.type & 128) === 0,
          errorKey: 'textDe',
          tab: 'inhalt'
        },
        {
          value: this.teaser.titleFr,
          required: (this.teaser.type & 128) === 0,
          errorKey: 'titleFr',
          tab: 'inhalt'
        },
        {
          value: this.teaser.textFr,
          required: (this.teaser.type & 128) === 0,
          errorKey: 'textFr',
          tab: 'inhalt'
        },
        {
          value: this.teaser.titleEn,
          required: (this.teaser.type & 128) === 0,
          errorKey: 'titleEn',
          tab: 'inhalt'
        },
        {
          value: this.teaser.textEn,
          required: (this.teaser.type & 128) === 0,
          errorKey: 'textEn',
          tab: 'inhalt'
        },
        {
          value: this.teaser.ctaTextDe,
          required: (this.teaser.type & 128) === 0,
          errorKey: 'ctaTextDe',
          tab: 'inhalt'
        },
        {
          value: this.teaser.ctaUrlDe,
          errorKey: 'ctaUrlDe',
          tab: 'inhalt',
          customRule: new Promise((resolve, reject) => {
            if ((this.teaser.ctaUrlDe === undefined || this.teaser.ctaUrlDe === null || this.teaser.ctaUrlDe.trim().length === 0) && (this.teaser.leistungsgruppeId === undefined || this.teaser.leistungsgruppeId === null || this.teaser.leistungsgruppeId.trim().length === 0)) {
              reject('Ohne eine Leistungsgruppe muss dieser Link angegeben werden');
            }
            resolve();
          })
        },
        {
          value: this.teaser.ctaTextFr,
          required: (this.teaser.type & 128) === 0,
          errorKey: 'ctaTextFr',
          tab: 'inhalt'
        },
        {
          value: this.teaser.ctaUrlFr,
          errorKey: 'ctaUrlFr',
          tab: 'inhalt',
          customRule: new Promise((resolve, reject) => {
            if ((this.teaser.ctaUrlFr === undefined || this.teaser.ctaUrlFr === null || this.teaser.ctaUrlFr.trim().length === 0) && (this.teaser.leistungsgruppeId === undefined || this.teaser.leistungsgruppeId === null || this.teaser.leistungsgruppeId.trim().length === 0)) {
              reject('Ohne eine Leistungsgruppe muss dieser Link angegeben werden');
            }
            resolve();
          })
        },
        {
          value: this.teaser.ctaTextEn,
          required: (this.teaser.type & 128) === 0,
          errorKey: 'ctaTextEn',
          tab: 'inhalt'
        },
        {
          value: this.teaser.ctaUrlEn,
          errorKey: 'ctaUrlEn',
          tab: 'inhalt',
          customRule: new Promise((resolve, reject) => {
            if ((this.teaser.ctaUrlEn === undefined || this.teaser.ctaUrlEn === null || this.teaser.ctaUrlEn.trim().length === 0) && (this.teaser.leistungsgruppeId === undefined || this.teaser.leistungsgruppeId === null || this.teaser.leistungsgruppeId.trim().length === 0)) {
              reject('Ohne eine Leistungsgruppe muss dieser Link angegeben werden');
            }
            resolve();
          })
        },
        {
          value: this.teaser.titleDe2,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'titleDe2',
          tab: 'inhalt'
        },
        {
          value: this.teaser.textDe2,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'textDe2',
          tab: 'inhalt'
        },
        {
          value: this.teaser.titleFr2,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'titleFr2',
          tab: 'inhalt'
        },
        {
          value: this.teaser.textFr2,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'textFr2',
          tab: 'inhalt'
        },
        {
          value: this.teaser.titleEn2,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'titleEn2',
          tab: 'inhalt'
        },
        {
          value: this.teaser.textEn2,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'textEn2',
          tab: 'inhalt'
        },
        {
          value: this.teaser.ctaTextDe2,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'ctaTextDe2',
          tab: 'inhalt'
        },
        {
          value: this.teaser.ctaUrlDe2,
          errorKey: 'ctaUrlDe2',
          tab: 'inhalt',
          customRule: new Promise((resolve, reject) => {
            if ((this.teaser.ctaUrlDe2 === undefined || this.teaser.ctaUrlDe2 === null || this.teaser.ctaUrlDe2.trim().length === 0) && (this.teaser.type & 4) > 0 && (this.teaser.leistungsgruppeId === undefined || this.teaser.leistungsgruppeId === null || this.teaser.leistungsgruppeId.trim().length === 0)) {
              reject('Ohne eine Leistungsgruppe muss dieser Link angegeben werden');
            }
            resolve();
          })
        },
        {
          value: this.teaser.ctaTextFr2,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'ctaTextFr2',
          tab: 'inhalt'
        },
        {
          value: this.teaser.ctaUrlFr2,
          errorKey: 'ctaUrlFr2',
          tab: 'inhalt',
          customRule: new Promise((resolve, reject) => {
            if ((this.teaser.ctaUrlFr2 === undefined || this.teaser.ctaUrlFr2 === null || this.teaser.ctaUrlFr2.trim().length === 0) && (this.teaser.type & 4) > 0 && (this.teaser.leistungsgruppeId === undefined || this.teaser.leistungsgruppeId === null || this.teaser.leistungsgruppeId.trim().length === 0)) {
              reject('Ohne eine Leistungsgruppe muss dieser Link angegeben werden');
            }
            resolve();
          })
        },
        {
          value: this.teaser.ctaTextEn2,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'ctaTextEn2',
          tab: 'inhalt'
        },
        {
          value: this.teaser.ctaUrlEn2,
          errorKey: 'ctaUrlEn2',
          tab: 'inhalt',
          customRule: new Promise((resolve, reject) => {
            if ((this.teaser.ctaUrlEn2 === undefined || this.teaser.ctaUrlEn2 === null || this.teaser.ctaUrlEn2.trim().length === 0) && (this.teaser.type & 4) > 0 && (this.teaser.leistungsgruppeId === undefined || this.teaser.leistungsgruppeId === null || this.teaser.leistungsgruppeId.trim().length === 0)) {
              reject('Ohne eine Leistungsgruppe muss dieser Link angegeben werden');
            }
            resolve();
          })
        },
        {
          value: this.teaser.titleDe3,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'titleDe3',
          tab: 'inhalt'
        },
        {
          value: this.teaser.textDe3,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'textDe3',
          tab: 'inhalt'
        },
        {
          value: this.teaser.titleFr3,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'titleFr3',
          tab: 'inhalt'
        },
        {
          value: this.teaser.textFr3,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'textFr3',
          tab: 'inhalt'
        },
        {
          value: this.teaser.titleEn3,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'titleEn3',
          tab: 'inhalt'
        },
        {
          value: this.teaser.textEn3,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'textEn3',
          tab: 'inhalt'
        },
        {
          value: this.teaser.ctaTextDe3,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'ctaTextDe3',
          tab: 'inhalt'
        },
        {
          value: this.teaser.ctaUrlDe3,
          errorKey: 'ctaUrlDe3',
          tab: 'inhalt',
          customRule: new Promise((resolve, reject) => {
            if ((this.teaser.ctaUrlDe3 === undefined || this.teaser.ctaUrlDe3 === null || this.teaser.ctaUrlDe3.trim().length === 0) && (this.teaser.type & 4) > 0 && (this.teaser.leistungsgruppeId === undefined || this.teaser.leistungsgruppeId === null || this.teaser.leistungsgruppeId.trim().length === 0)) {
              reject('Ohne eine Leistungsgruppe muss dieser Link angegeben werden');
            }
            resolve();
          })
        },
        {
          value: this.teaser.ctaTextFr3,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'ctaTextFr3',
          tab: 'inhalt'
        },
        {
          value: this.teaser.ctaUrlFr3,
          errorKey: 'ctaUrlFr3',
          tab: 'inhalt',
          customRule: new Promise((resolve, reject) => {
            if ((this.teaser.ctaUrlFr3 === undefined || this.teaser.ctaUrlFr3 === null || this.teaser.ctaUrlFr3.trim().length === 0) && (this.teaser.type & 4) > 0 && (this.teaser.leistungsgruppeId === undefined || this.teaser.leistungsgruppeId === null || this.teaser.leistungsgruppeId.trim().length === 0)) {
              reject('Ohne eine Leistungsgruppe muss dieser Link angegeben werden');
            }
            resolve();
          })
        },
        {
          value: this.teaser.ctaTextEn3,
          required:
            (this.teaser.type & 128) === 0 && (this.teaser.type & 4) > 0,
          errorKey: 'ctaTextEn3',
          tab: 'inhalt'
        },
        {
          value: this.teaser.ctaUrlEn3,
          errorKey: 'ctaUrlEn3',
          tab: 'inhalt',
          customRule: new Promise((resolve, reject) => {
            if ((this.teaser.ctaUrlEn3 === undefined || this.teaser.ctaUrlEn3 === null || this.teaser.ctaUrlEn3.trim().length === 0) && (this.teaser.type & 4) > 0 && (this.teaser.leistungsgruppeId === undefined || this.teaser.leistungsgruppeId === null || this.teaser.leistungsgruppeId.trim().length === 0)) {
              reject('Ohne eine Leistungsgruppe muss dieser Link angegeben werden');
            }
            resolve();
          })
        },
        {
          value: this.teaser.imageLandscapeDe,
          required: (this.teaser.type & 1) > 0 || (this.teaser.type & 128) > 0,
          errorKey: 'imageLandscapeDe',
          type: 'image',
          image: this.$refs['fileInputImageLandscapeDe_preview'],
          minWidth: this.imageLandscapeMaxWidth,
          minHeight: this.imageLandscapeMaxHeight,
          ratio: this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight,
          ratioName: this.aspectRationName(
            this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imagePortraitDe,
          required: (this.teaser.type & 1) > 0 || (this.teaser.type & 128) > 0,
          errorKey: 'imagePortraitDe',
          type: 'image',
          image: this.$refs['fileInputImagePortraitDe_preview'],
          minWidth: this.imagePortraitMaxWidth,
          minHeight: this.imagePortraitMaxHeight,
          ratio: this.imagePortraitMaxWidth / this.imagePortraitMaxHeight,
          ratioName: this.aspectRationName(
            this.imagePortraitMaxWidth / this.imagePortraitMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imageLandscapeFr,
          required: (this.teaser.type & 128) > 0,
          errorKey: 'imageLandscapeFr',
          type: 'image',
          image: this.$refs['fileInputImageLandscapeFr_preview'],
          minWidth: this.imageLandscapeMaxWidth,
          minHeight: this.imageLandscapeMaxHeight,
          ratio: this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight,
          ratioName: this.aspectRationName(
            this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imagePortraitFr,
          required: (this.teaser.type & 128) > 0,
          errorKey: 'imagePortraitFr',
          type: 'image',
          image: this.$refs['fileInputImagePortraitFr_preview'],
          minWidth: this.imagePortraitMaxWidth,
          minHeight: this.imagePortraitMaxHeight,
          ratio: this.imagePortraitMaxWidth / this.imagePortraitMaxHeight,
          ratioName: this.aspectRationName(
            this.imagePortraitMaxWidth / this.imagePortraitMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imageLandscapeEn,
          required: (this.teaser.type & 128) > 0,
          errorKey: 'imageLandscapeEn',
          type: 'image',
          image: this.$refs['fileInputImageLandscapeEn_preview'],
          minWidth: this.imageLandscapeMaxWidth,
          minHeight: this.imageLandscapeMaxHeight,
          ratio: this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight,
          ratioName: this.aspectRationName(
            this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imagePortraitEn,
          required: (this.teaser.type & 128) > 0,
          errorKey: 'imagePortraitEn',
          type: 'image',
          image: this.$refs['fileInputImagePortraitEn_preview'],
          minWidth: this.imagePortraitMaxWidth,
          minHeight: this.imagePortraitMaxHeight,
          ratio: this.imagePortraitMaxWidth / this.imagePortraitMaxHeight,
          ratioName: this.aspectRationName(
            this.imagePortraitMaxWidth / this.imagePortraitMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imageLandscapeDe2,
          required: (this.teaser.type & 4) > 0 && (this.teaser.type & 128) > 0,
          errorKey: 'imageLandscapeDe2',
          type: 'image',
          image: this.$refs['fileInputImageLandscapeDe2_preview'],
          minWidth: this.imageLandscapeMaxWidth,
          minHeight: this.imageLandscapeMaxHeight,
          ratio: this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight,
          ratioName: this.aspectRationName(
            this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imagePortraitDe2,
          required: (this.teaser.type & 4) > 0 && (this.teaser.type & 128) > 0,
          errorKey: 'imagePortraitDe2',
          type: 'image',
          image: this.$refs['fileInputImagePortraitDe2_preview'],
          minWidth: this.imagePortraitMaxWidth,
          minHeight: this.imagePortraitMaxHeight,
          ratio: this.imagePortraitMaxWidth / this.imagePortraitMaxHeight,
          ratioName: this.aspectRationName(
            this.imagePortraitMaxWidth / this.imagePortraitMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imageLandscapeFr2,
          required: (this.teaser.type & 4) > 0 && (this.teaser.type & 128) > 0,
          errorKey: 'imageLandscapeFr2',
          type: 'image',
          image: this.$refs['fileInputImageLandscapeFr2_preview'],
          minWidth: this.imageLandscapeMaxWidth,
          minHeight: this.imageLandscapeMaxHeight,
          ratio: this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight,
          ratioName: this.aspectRationName(
            this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imagePortraitFr2,
          required: (this.teaser.type & 4) > 0 && (this.teaser.type & 128) > 0,
          errorKey: 'imagePortraitFr2',
          type: 'image',
          image: this.$refs['fileInputImagePortraitFr2_preview'],
          minWidth: this.imagePortraitMaxWidth,
          minHeight: this.imagePortraitMaxHeight,
          ratio: this.imagePortraitMaxWidth / this.imagePortraitMaxHeight,
          ratioName: this.aspectRationName(
            this.imagePortraitMaxWidth / this.imagePortraitMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imageLandscapeEn2,
          required: (this.teaser.type & 4) > 0 && (this.teaser.type & 128) > 0,
          errorKey: 'imageLandscapeEn2',
          type: 'image',
          image: this.$refs['fileInputImageLandscapeEn2_preview'],
          minWidth: this.imageLandscapeMaxWidth,
          minHeight: this.imageLandscapeMaxHeight,
          ratio: this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight,
          ratioName: this.aspectRationName(
            this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imagePortraitEn2,
          required: (this.teaser.type & 4) > 0 && (this.teaser.type & 128) > 0,
          errorKey: 'imagePortraitEn2',
          type: 'image',
          image: this.$refs['fileInputImagePortraitEn2_preview'],
          minWidth: this.imagePortraitMaxWidth,
          minHeight: this.imagePortraitMaxHeight,
          ratio: this.imagePortraitMaxWidth / this.imagePortraitMaxHeight,
          ratioName: this.aspectRationName(
            this.imagePortraitMaxWidth / this.imagePortraitMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imageLandscapeDe3,
          required: (this.teaser.type & 4) > 0 && (this.teaser.type & 128) > 0,
          errorKey: 'imageLandscapeDe3',
          type: 'image',
          image: this.$refs['fileInputImageLandscapeDe3_preview'],
          minWidth: this.imageLandscapeMaxWidth,
          minHeight: this.imageLandscapeMaxHeight,
          ratio: this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight,
          ratioName: this.aspectRationName(
            this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imagePortraitDe3,
          required: (this.teaser.type & 4) > 0 && (this.teaser.type & 128) > 0,
          errorKey: 'imagePortraitDe3',
          type: 'image',
          image: this.$refs['fileInputImagePortraitDe3_preview'],
          minWidth: this.imagePortraitMaxWidth,
          minHeight: this.imagePortraitMaxHeight,
          ratio: this.imagePortraitMaxWidth / this.imagePortraitMaxHeight,
          ratioName: this.aspectRationName(
            this.imagePortraitMaxWidth / this.imagePortraitMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imageLandscapeFr3,
          required: (this.teaser.type & 4) > 0 && (this.teaser.type & 128) > 0,
          errorKey: 'imageLandscapeFr3',
          type: 'image',
          image: this.$refs['fileInputImageLandscapeFr3_preview'],
          minWidth: this.imageLandscapeMaxWidth,
          minHeight: this.imageLandscapeMaxHeight,
          ratio: this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight,
          ratioName: this.aspectRationName(
            this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imagePortraitFr3,
          required: (this.teaser.type & 4) > 0 && (this.teaser.type & 128) > 0,
          errorKey: 'imagePortraitFr3',
          type: 'image',
          image: this.$refs['fileInputImagePortraitFr3_preview'],
          minWidth: this.imagePortraitMaxWidth,
          minHeight: this.imagePortraitMaxHeight,
          ratio: this.imagePortraitMaxWidth / this.imagePortraitMaxHeight,
          ratioName: this.aspectRationName(
            this.imagePortraitMaxWidth / this.imagePortraitMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imageLandscapeEn3,
          required: (this.teaser.type & 4) > 0 && (this.teaser.type & 128) > 0,
          errorKey: 'imageLandscapeEn3',
          type: 'image',
          image: this.$refs['fileInputImageLandscapeEn3_preview'],
          minWidth: this.imageLandscapeMaxWidth,
          minHeight: this.imageLandscapeMaxHeight,
          ratio: this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight,
          ratioName: this.aspectRationName(
            this.imageLandscapeMaxWidth / this.imageLandscapeMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.imagePortraitEn3,
          required: (this.teaser.type & 4) > 0 && (this.teaser.type & 128) > 0,
          errorKey: 'imagePortraitEn3',
          type: 'image',
          image: this.$refs['fileInputImagePortraitEn3_preview'],
          minWidth: this.imagePortraitMaxWidth,
          minHeight: this.imagePortraitMaxHeight,
          ratio: this.imagePortraitMaxWidth / this.imagePortraitMaxHeight,
          ratioName: this.aspectRationName(
            this.imagePortraitMaxWidth / this.imagePortraitMaxHeight
          ),
          tab: 'bilder'
        },
        {
          value: this.teaser.published,
          required: true,
          errorKey: 'published',
          tab: 'optionen',
          type: 'daterange',
          customRule: new Promise((resolve, reject) => {
            ApiService.checkTeaserDateRange({
              published: this.teaser.published,
              type: this.teaser.type,
              fairSeries: this.teaser.fairSeries,
              _id: this.teaser._id
            }).then(res => {
              if (res.data._id === undefined) {
                resolve()
              } else {
                console.log(res)
                const start = new Date(res.data.published.start)
                const end = new Date(res.data.published.end)
                reject(
                  'Der Teaser "' +
                    res.data.internalName +
                    '" mit derselben Messe-Reihe überschneidet diesen Zeitraum (' +
                    that.$d(start, 'L') +
                    ' bis ' +
                    that.$d(end, 'L') +
                    ')'
                )
              }
            })
          })
        },
        {
          value: this.teaser.fair,
          required: (this.teaser.type & 1) === 0,
          errorKey: 'fair',
          tab: 'optionen'
        },
        {
          value: this.teaser.fairType,
          required: false,
          errorKey: 'fairType',
          tab: 'optionen'
        },
        {
          value: this.teaser.registrationState,
          required: (this.teaser.type & 1) === 0,
          errorKey: 'registrationState',
          type: 'bitMaskCheckboxes',
          tab: 'optionen'
        },
        {
          value: this.teaser.relatedTask,
          required: (this.teaser.type & 1) === 0,
          errorKey: 'relatedTask',
          tab: 'optionen'
        }
      ]
      return validationRules
    },
    saveTeaser() {
      FormValidator.validateForm(this.getValidationRules(), this.errors).then(
        () => {
          let action = this.teaser._id ? 'updateTeaser' : 'createTeaser'
          let allowedStates = [200, 201]

          ApiService[action](this.teaser).then(
            result => {
              this.teaser = result.data.obj
              if (allowedStates.includes(result.status)) {
                this.successMessageDismissCountdown = 5
              }
            },
            error => {
              console.warn(error)
            }
          )
        }
      )
    },
    addInfotext() {
      this.editStep.infoTexts.push({})
    },
    removeInfoText(idx) {
      console.info('Remove item at: ' + idx.toString())
      this.editStep.infoTexts.splice(idx, 1)
    },
    setImageLandscapeDe(file) {
      this.setImage(file, 'imageLandscapeDe')
    },
    setImagePortraitDe(file) {
      this.setImage(file, 'imagePortraitDe')
    },
    setImageLandscapeFr(file) {
      this.setImage(file, 'imageLandscapeFr')
    },
    setImagePortraitFr(file) {
      this.setImage(file, 'imagePortraitFr')
    },
    setImageLandscapeEn(file) {
      this.setImage(file, 'imageLandscapeEn')
    },
    setImagePortraitEn(file) {
      this.setImage(file, 'imagePortraitEn')
    },
    setImageLandscapeDe2(file) {
      this.setImage(file, 'imageLandscapeDe2')
    },
    setImagePortraitDe2(file) {
      this.setImage(file, 'imagePortraitDe2')
    },
    setImageLandscapeFr2(file) {
      this.setImage(file, 'imageLandscapeFr2')
    },
    setImagePortraitFr2(file) {
      this.setImage(file, 'imagePortraitFr2')
    },
    setImageLandscapeEn2(file) {
      this.setImage(file, 'imageLandscapeEn2')
    },
    setImagePortraitEn2(file) {
      this.setImage(file, 'imagePortraitEn2')
    },
    setImageLandscapeDe3(file) {
      this.setImage(file, 'imageLandscapeDe3')
    },
    setImagePortraitDe3(file) {
      this.setImage(file, 'imagePortraitDe3')
    },
    setImageLandscapeFr3(file) {
      this.setImage(file, 'imageLandscapeFr3')
    },
    setImagePortraitFr3(file) {
      this.setImage(file, 'imagePortraitFr3')
    },
    setImageLandscapeEn3(file) {
      this.setImage(file, 'imageLandscapeEn3')
    },
    setImagePortraitEn3(file) {
      this.setImage(file, 'imagePortraitEn3')
    },
    setImage(file, key) {
      this.errors[key].hasError = false
      this.teaser[key] = file.dataUrl
    }
  },
  mounted() {
    if (this.$route.params.id) {
      ApiService.getTeaser(this.$route.params.id).then(res => {
        this.teaser = res.data

        if (this.teaser._id) {
          history.pushState(
            {},
            null,
            window.document.location.pathname + '#inhalt'
          )
          window.dispatchEvent(new HashChangeEvent('hashchange'))
        }
        this.setFair()
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/css/variables.scss';

.o-admin__teaser {
  padding: 6rem 0;
}

.list-group-item {
  padding: 0.333rem 0;
  vertical-align: center;
  display: block;

  &:nth-child(even) {
    background-color: #f7f6f3;
  }
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.bos-timeflow {
  text-align: center;
  list-style: none;
  display: inline-table;
  margin: 0 0 4rem 0;

  li {
    display: inline;
    margin: 0;

    span {
      display: block;
      float: left;
      height: 44px;
      background: rgba(104, 115, 116, 0.3);
      text-align: center;
      padding: 14px 10px 0 30px;
      position: relative;
      margin: 0 4px 0 0;

      font-size: $timeflow-font-size;
      text-decoration: none;
      color: #fff;

      &:after {
        content: '';
        border-top: 22px solid transparent;
        border-bottom: 22px solid transparent;
        border-left: 20px solid rgba(104, 115, 116, 0.3);
        position: absolute;
        right: -20px;
        top: 0;
        z-index: 1;
      }

      &:before {
        content: '';
        border-top: 22px solid transparent;
        border-bottom: 22px solid transparent;
        border-left: 20px solid #fff;
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    &:first-child span {
      padding-left: 24px;

      &:before {
        display: none;
      }
    }

    &:last-child span {
      padding-right: 20px;

      &:after {
        display: none;
      }
    }

    &.active span {
      background: rgba(46, 150, 153, 0.7);

      &:after {
        border-left-color: rgba(46, 150, 153, 0.7);
      }
    }
  }
}

.top-buttons {
  float: right;
  text-align: right;

  button {
    margin-right: 1.333rem;

    &:last-of-type {
      margin-right: 0;
    }
  }
}

hr {
  margin: 1.333rem 0 4rem 0;
  border: none;
  border-bottom: 1px solid #c9c9c9;
}

.empty {
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  padding: 0.333rem;
  &:after {
    display: block;
    width: 100%;
    content: 'hierher ziehen';
    text-align: center;
    color: rgba(0, 0, 0, 0.3);
  }
}

input.fileinput.error + label,
.c-errormessage {
  color: red;
}

.hint {
  font-size: 0.8rem;
}

.preview-image {
  max-width: 100%;
}
</style>
